<template>
    <div class="banner banner--theme banner--split">
        <div class="banner-primary">
            <div class="container">

                <div class="col-content">
                    <div class="banner-content">
                        <h1>{{data.title}}</h1>
                        <colour-card v-if="data.colour" :data="data.colour" />

                        <p v-html="data.content"></p>
                        <img v-if="data.icon" :src="data.icon" :alt="data.title" class="profile-image">

                        
                        <a class="button button--solid-black banner-split-cta " :href="data.primaryLink" :aria-label="data.primaryLabel" :title="data.primaryLabel">{{data.primaryLabel}}</a>
                        <a class="button button--clear-black banner-split-cta" :href="data.secondaryLink" :aria-label="data.secondaryLabel" :title="data.secondaryLabel">{{data.secondaryLabel}}</a>
                    </div>
                </div>

                <div class="col-image">
                    <div class="project-image" :style="{ backgroundImage: data.image ? 'url(' + data.image + ')' : 'initial' }"></div>
                    <p v-html="data.imagecontent"></p>
                </div>


            </div>
        </div>
    </div>
</template>

<script>

    import { Colour } from "../../components";
    import ColourCard from "../../components/Cards/ColourCard";

    export default {
        name: "banner-split",
        components: {
            Colour,
            ColourCard
        },
        props: {
            data: {
                type: Object
            }
        },
        data() {
            return {

            };
        },
        computed: {

        },
        methods: {

        },
        mounted() {

        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";
    @import "../../../scss/abstracts/mixins";

    .banner--split {
        position: relative;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;

        min-height: 530px; // CS-217 adjusted
        margin-bottom: 2rem;

        @media #{$lg} {
            //max-height: 380px;
        }

        .container {
            display: block;

            @media #{$lg} {
                display: flex;
            }

            .col-content {
                width: 100%;
                display: block;

                @media #{$lg} {
                    width: 45%;
                    display: flex;
                }

                .banner-content {
                    max-width: 100%;
                    margin-top: 0;
                    padding-right: 0;

                    @media #{$lg} {
                        max-width: 650px;
                        margin-top: 130px;
                        padding-right: 2rem;
                    }


                    .profile-image{
                        max-width: 165px;
                        margin-top:2.5rem;
                        margin-bottom:2.5rem;
                    }
                }
            }

            .col-image {
                width: 100vw;
                width: var(--vw-100);

                position: relative;
                bottom: 0;
                min-height: 0;
                overflow: hidden;

                right: auto;
                left: -2rem;

                @media #{$sm} {
                    left: ($grid-gutter-base+$grid-col-base) * (-1);
                    left: calc(((var(--vw-100) - #{$grid-container-inner-width}) / 2) * (-1) );
                }

                @media #{$lg} {
                    left: auto;
                    right: ($grid-gutter-base+$grid-col-base) * (-1);
                    right: calc(((var(--vw-100) - #{$grid-container-inner-width}) / 2) * (-1) );

                    width: 55%;
                    position: relative;
                    min-height: calc(100% - 130px);
                    max-height: calc(100% - 130px);
                    margin: auto;
                    margin-top:130px;
                }

                p{
                    padding-left: 2rem;
                    padding-right: 2rem;
                    


                     @media #{$sm} {
                         padding-left: 0;
                         padding-right: 0;

                     }

                }

                .project-image {
                    width: 100%;
                    height: 0px;
                    padding-bottom: 54.478%;
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                .project-details {
                    display: flex;
                    border-bottom: 1px solid;
                    padding: 2rem 0;
                    flex-direction: row;

                    .project-details--col {
                        line-height: 34px;

                        &:first-of-type {
                            margin-right: 4rem;
                        }

                        strong {
                            min-width: 130px;
                            display: inline-block;
                        }
                    }
                }
            }
        }

        .banner-primary {
            .container {
                .col-content {
                    height: auto;
                    padding: 120px 0 60px 0;

                    @media #{$lg} {
                        padding: 0;
                    }
                }
            }
        }
    }

    img {
        display: block;
    }
    

    .banner-split-cta{
        display:block;
        max-width: 210px;
        margin-top: 0;
        margin-bottom: 10px;

        @media #{$lg} {
            display: inline-block;
            margin-right: 2rem;
        }

    }

    //@media #{$sm} {}
    //@media #{$md} {}
    //@media #{$lg} {}
    //@media #{$xl} {}

</style>
